import type { LegacyProgram } from '@/pages/legacy/shared';

export const courtOrderOptions = ['Residential SUD Tx', 'IOP SUD Tx', 'Anger Management', 'Domestic Violence', 'Residential SUD Tx Directly from Custody', 'LAI', 'Other'];
const hearingTypes: Partial<Record<LegacyProgram, string[]>> = {
  odrhousing: ['appearance', 'non-appearance', 'graduation-appearance'],
  prg_wmn: ['in person', 'virtual', 'non-appearance'],
};
export const legalFieldOptions = (entity: string, field: string, program?: LegacyProgram): string[] | undefined => {
  if (entity === 'court' && field === 'courtorder') return courtOrderOptions;
  if (entity !== 'hearings') return undefined;
  if (field === 'hearingdetails' && (!program || hearingTypes[program])) return ['suitability', 'reinstatement', 'progress report'];
  if (field === 'reinstatement_number') return ['1', '2', '3', '4', '5', '6'];
  if (field === 'hearingtype') return program ? hearingTypes[program] : Array.from(new Set(Object.values(hearingTypes).flat()));
  return undefined;
};
